/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Thresholds_FtpInputs */

const en_ui_thresholds_ftp = /** @type {(inputs: Ui_Thresholds_FtpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FTP (watts)`)
};

const de_ui_thresholds_ftp = /** @type {(inputs: Ui_Thresholds_FtpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FTP (Watt)`)
};

/**
* | output |
* | --- |
* | "FTP (watts)" |
*
* @param {Ui_Thresholds_FtpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_thresholds_ftp = /** @type {((inputs?: Ui_Thresholds_FtpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Thresholds_FtpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_thresholds_ftp(inputs)
	return de_ui_thresholds_ftp(inputs)
});